import Utils from '../../utility'

const initialState = {
  products: [],
  images: [],
  count: 0,
  order: 'ASC',
  sortField: 'orderDate',
  offset: 1,
  take: 10,
  search: '',
}
export const returnReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case `${Utils.ActionName.RETURN}`:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return { ...state }
  }
}
